import { Box, Slider, SliderProps } from '@mui/material';

import { AI_SIMULATION_TYPES } from 'common/constants/AISimulationConstants';
import { PROGRESS_BAR_ELEMENTS } from 'common/constants/CitationDetails';
import { capitalizeEachWord } from 'common/utils/utilFunctions';

import styles from './StepperProgressBar.module.scss';

const { currentProgressColor, progressColor, dotColor } = styles;

type IStepper = {
	status: string;
	progressBarElements: any;
} & SliderProps;

const { CONTROL_TEST_SCRIPTS } = AI_SIMULATION_TYPES;

const StepperProgressBar = (taskStatus: IStepper) => {
	const { status, progressBarElements, ...otherProps } = taskStatus;

	const isCompleteStatus =
		status === PROGRESS_BAR_ELEMENTS.COMPLETE ||
		status === capitalizeEachWord(CONTROL_TEST_SCRIPTS);

	const getValue = (status: string) => {
		let value: any;
		progressBarElements.forEach((res: any) => {
			if (res.label === status) {
				value = res;
			}
		});
		return (
			value || {
				index: 1,
				value: 0,
				label: '',
			}
		);
	};

	return (
		<Box>
			<Slider
				defaultValue={getValue(status).value}
				marks={progressBarElements}
				{...otherProps}
				sx={{
					'& .MuiSlider-rail': {
						height: 6,
						width: isCompleteStatus ? '96%' : '100%',
					},
					'& .MuiSlider-track': {
						height: 6,
						color: currentProgressColor,
					},
					'& .MuiSlider-thumb': {
						width: 12,
						height: 12,
						color: currentProgressColor,
					},
					'& .MuiSlider-markLabel': {
						fontSize: '0.813rem',
						color: progressColor,
						'@media (max-width: 1650px)': {
							fontSize: '0.6rem',
						},
						'@media (max-width: 1500px)': {
							fontSize: '0.5rem',
						},
						'@media (max-width: 1200px)': {
							fontSize: '0.42rem',
						},
					},
					[`& .MuiSlider-markLabelActive[data-index="${
						getValue(status).index
					}"]`]: {
						fontSize: '0.816rem',
						color: currentProgressColor,
						fontWeight: 700,
						'@media (max-width: 1650px)': {
							fontSize: '0.6rem',
						},
						'@media (max-width: 1500px)': {
							fontSize: '0.5rem',
						},
						'@media (max-width: 1200px)': {
							fontSize: '0.42rem',
						},
					},
					'& .MuiSlider-mark': {
						backgroundColor: dotColor,
					},
					'& .MuiSlider-markActive': {
						backgroundColor: currentProgressColor,
					},
				}}
			/>
		</Box>
	);
};

export default StepperProgressBar;
